export default "__VITE_ASSET__78b97a64__"